import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { GridSortModel } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import HttpService from "../../../Hooks/Https-services";
import { APIRoutes, PageRoutes } from "../../../Utils/constant";
import VideoListTable from "./VideoListTable";
import { Button } from "@mui/material";
import { useLoadData } from "../../../Context/LoadDataContext";
export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number | string;
}

export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export function a11yProps(index: number | string) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const BumperVideos = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [bumpers, setBumpers] = React.useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 10,
    page: 0,
  });
  const { isRefresh } = useLoadData();
  const [sortModel, setSortModel] = React.useState<GridSortModel>([]);
  const [_searchQuery, _setSearchQuery] = React.useState("");
  const [debouncedQuery, setDebouncedQuery] = React.useState(_searchQuery);
  const [totalPage, setTotalPage] = React.useState(10);
  const navigate = useNavigate();
  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setSortModel(newSortModel);
  };

  const GetBumpers = React.useCallback(async () => {
    const query: any = {
      page: paginationModel.page + 1,
      limit: paginationModel.pageSize,

      is_active: value === 0 ? "true" : "false",
    };

    try {
      const res = await HttpService.get(
        APIRoutes.GetBumpers + "?" + new URLSearchParams(query).toString()
      );
      setBumpers(res.data.data);
      setTotalPage(res.data.pagination?.totalRecords);
    } catch (error) {}
  }, [paginationModel.page, paginationModel.pageSize, value, isRefresh]);
  React.useEffect(() => {
    GetBumpers();
  }, [GetBumpers]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Active" {...a11yProps(0)} />
          <Tab label="Inactive" {...a11yProps(0)} />
        </Tabs>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 3, pr: 3 }}>
        <Button
          variant="contained"
          onClick={() => navigate(PageRoutes.BumperVideo.replace(":id", "0"))}
        >
          Add Bumper Video
        </Button>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <VideoListTable
          bumpers={bumpers}
          totalPage={totalPage}
          handleSortModelChange={handleSortModelChange}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <VideoListTable
          bumpers={bumpers}
          totalPage={totalPage}
          handleSortModelChange={handleSortModelChange}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
        />
      </CustomTabPanel>
    </Box>
  );
};
export default BumperVideos;
